module.exports = __webpack_public_path__ + "static/9-8565daad9e172fb577b052397ab245df.jpg";